/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import Loader from 'components/atoms/loader';
import SquareLoader from 'components/atoms/square_loader';
import Switch from 'components/atoms/switch';
import MonitoringRuleRow from 'components/molecules/monitoring_rule_row';
import MonitoringPrioritySounds from 'components/molecules/monitoring_priority_sounds';
import { MonitoringSettings } from 'hooks/useMonitoringSettings';
import { MAX_KEYWORD_LENGTH } from 'services/monitoring_settings';
import { Container } from './styles';

interface MonitoringNotificationSettingsProps {
  settings: MonitoringSettings;
  onActivateDesktop: () => void;
}

const MonitoringNotificationSettings = ({
  settings,
  onActivateDesktop,
}: MonitoringNotificationSettingsProps) => {
  return (
    <Container className="card shadow mb-4">
      <div className="card-body">
        <h5 className="font-weight-bold mb-3">Notificações e Palavras-chaves</h5>

        {settings.desktopBlocked && (
          <div role="alert" className="alert alert-warning desktop-warning">
            Você configurou para exibir notificações na área de trabalho, mas as notificações estão
            desativadas no seu navegador.{' '}
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                onActivateDesktop();
              }}
            >
              Clique aqui para ativar.
            </a>
          </div>
        )}

        {settings.saveError && (
          <div role="alert" className="alert alert-warning">
            {settings.saveError}
          </div>
        )}

        {settings.loadError && (
          <div role="alert" className="alert alert-warning">
            Não foi possível carregar as configurações.{' '}
            <button
              type="button"
              className="btn btn-link p-0 align-baseline"
              onClick={settings.retryLoad}
            >
              Tentar de novo
            </button>
          </div>
        )}

        {settings.loading && <Loader />}
        {settings.loading || settings.loadError ? null : (
          <>
            <div className="tour-monitoring-notifications mb-3">
              <p className="mb-1">Notificação de mensagens</p>
              <Switch handleChange={settings.toggleEnabled} checked={settings.enabled} />
              {!settings.enabled && (
                <p className="text-muted small mt-1 mb-0" role="status">
                  As notificações estão desativadas: nenhum aviso é enviado. Ative para receber os
                  avisos configurados abaixo.
                </p>
              )}
            </div>

            <div className="tour-monitoring-keywords">
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                  settings.addKeyword();
                }}
              >
                <label htmlFor="addKeywords">
                  Adicionar palavras-chave gerais para monitoramento
                </label>
                <div className="row">
                  <div className="col-md col-12">
                    <input
                      id="addKeywords"
                      type="text"
                      placeholder="Digite a palavra"
                      className={`form-control ${settings.keywordMessage ? 'is-invalid' : ''}`}
                      maxLength={MAX_KEYWORD_LENGTH}
                      onChange={(event) => settings.setKeyword(event.target.value)}
                      value={settings.keyword}
                    />
                    {settings.keywordMessage && (
                      <div className="invalid-feedback d-block">{settings.keywordMessage}</div>
                    )}
                    <SquareLoader customClass={settings.addingKeyword ? 'visible' : 'invisible'} />
                  </div>
                  <div className="col-md-auto col-12 pl-md-0 pl-3 mt-2 mt-md-0">
                    <button
                      type="submit"
                      disabled={!settings.keyword.trim() || settings.addingKeyword}
                      className="btn btn-primary btn-block"
                    >
                      Adicionar
                    </button>
                  </div>
                </div>
              </form>

              <div className="table-responsive-md mt-3">
                <table className="table rules-table">
                  <thead>
                    <tr>
                      <th scope="col">Mensagens Monitoradas</th>
                      <th scope="col">Nível de prioridade</th>
                      <th scope="col">Notificação por</th>
                      <th scope="col">Monitorar</th>
                      <th scope="col" aria-label="Excluir" />
                    </tr>
                  </thead>
                  <tbody>
                    {settings.rules.map((rule) => (
                      <MonitoringRuleRow
                        key={rule.keywordId ?? 'todas'}
                        rule={rule}
                        onPriority={(priority) => settings.changePriority(rule, priority)}
                        onChannel={(channel) => settings.toggleChannel(rule, channel)}
                        onActive={() => settings.toggleActive(rule)}
                        onRemove={
                          rule.keywordId === null ? null : () => settings.removeKeyword(rule)
                        }
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <MonitoringPrioritySounds sounds={settings.sounds} onChange={settings.changeSound} />
          </>
        )}
      </div>
    </Container>
  );
};

export default MonitoringNotificationSettings;
